import * as React from 'react';
import ProcessHeaderBase, {
  IProcessWarning,
} from '../ProcessHeaderBase/ProcessHeaderBase';
import { IProcessButton } from '../ProcessButtons/ProcessButtons';

interface IProps {
  selectedSubProcess?: IProcessButton;
  subprocesses: IProcessButton[];
  onSubprocessSelected: (subprocess: IProcessButton) => void;
  truncated?: boolean;
  warnings?: IProcessWarning[];
}

const checkWarningMessage = (
  p: IProcessButton,
  warnings?: IProcessWarning[]
) => {
  const warning = warnings && warnings.find(w => w.subProcess === p.Kod);
  return warning && warning.message;
};

/**
 * En implementering av ProcesHeaderBase för subprocesser
 */
class SubprocessHeader extends React.PureComponent<IProps> {
  render() {
    const subprocess = this.props.selectedSubProcess;

    return (
      <ProcessHeaderBase
        onSelect={this.props.onSubprocessSelected}
        content={this.props.subprocesses.map(p => ({
          Kod: p.Kod,
          Benamning: p.Benamning,
          Warning: checkWarningMessage(p, this.props.warnings),
        }))}
        selected={subprocess}
        backgroundColor="medium"
        truncated={this.props.truncated}
      />
    );
  }
}

export default SubprocessHeader;
